import { isEqual } from 'lodash';

export const Animals2 = (): Array<{ numbers: string[]; group: number; image: string }> =>
  Array.from({ length: 25 }, (_, index) => ({
    numbers: calculateNumbersForGroup(index + 1),
    group: index + 1,
    image: `assets/animals/${index + 1}.webp`,
  }));

/**
 * Calculates the numbers associated with a given group.
 * @param group The group number to calculate numbers for.
 * @returns An array of strings representing the numbers in the group.
 */
export const calculateNumbersForGroup = (group: number): string[] => {
  if (group === 25) {
    return ['97', '98', '99', '00'];
  }

  const start = (group - 1) * 4 + 1;
  return [
    start.toString().padStart(2, '0'),
    (start + 1).toString().padStart(2, '0'),
    (start + 2).toString().padStart(2, '0'),
    (start + 3).toString().padStart(2, '0'),
  ];
};

/**
 * Determines the prize group for a given prize based on its last two digits.
 * @param prize The prize value to evaluate.
 * @returns The prize group as a number.
 */
export const GetPrizeGroup = (prize: number | string): number => {
  const last2digits = prize.toString().slice(-2);
  return last2digits == '00'
    ? 25
    : Number(last2digits) % 4 == 0
      ? Number(last2digits) / 4
      : Math.floor(Number(last2digits) / 4) + 1;
};

/**
 * Finds the animal group that matches the given set of numbers.
 * @param number An array of strings representing the numbers to find in the animal groups.
 * @returns The animal group object if found, otherwise undefined.
 */
export const FindGroupOfNumbers = (number: string[]) => Animals2().find(animal => isEqual(animal.numbers, number));

/**
 * Retrieves the animal associated with a given prize based on its group.
 * @param prize The prize number to evaluate.
 * @returns The animal object corresponding to the prize group.
 */
export const GetPrizeAnimal = (prize: number) => Animals2()[GetPrizeGroup(prize) - 1];
